import type { AgentOutputType, PlanCode } from '@yingai/shared';

/** 品牌渐变（科技蓝 → 紫） */
export const BRAND_GRADIENT = 'linear-gradient(135deg, #2D6BFF 0%, #7B5CFF 100%)';

/** 输出类型展示文案 */
export const OUTPUT_LABEL: Record<AgentOutputType, string> = {
  text: '文本生成',
  image: '图像生成',
  both: '图文混合',
};

/** 套餐展示名 */
export const PLAN_LABEL: Record<PlanCode, string> = {
  free: '免费版',
  basic: '基础版',
  pro: '专业版',
  enterprise: '企业版',
};

/** 套餐主题色（用于卡片高亮） */
export const PLAN_COLOR: Record<PlanCode, string> = {
  free: '#94a3b8',
  basic: '#2D6BFF',
  pro: '#7B5CFF',
  enterprise: '#0EA5E9',
};

/** 头像占位渐变（按昵称稳定取色） */
const AVATAR_GRADIENTS = [
  'linear-gradient(135deg,#2D6BFF,#7B5CFF)',
  'linear-gradient(135deg,#0EA5E9,#22D3EE)',
  'linear-gradient(135deg,#F59E0B,#EF4444)',
  'linear-gradient(135deg,#10B981,#34D399)',
  'linear-gradient(135deg,#EC4899,#F472B6)',
];
export function avatarGradient(seed: string): string {
  let sum = 0;
  for (let i = 0; i < seed.length; i++) sum += seed.charCodeAt(i);
  return AVATAR_GRADIENTS[sum % AVATAR_GRADIENTS.length];
}
